import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  FaSearch, FaBox, FaCheckCircle, FaClock, FaTimesCircle, FaShieldAlt, FaUser,
  FaTh, FaList, FaSort, FaSortUp, FaSortDown, FaExternalLinkAlt, FaSyncAlt,
  FaExclamationTriangle, FaTimes, FaFilter, FaCopy,
} from "react-icons/fa";
import api from "../../api/axiosClient";

const S = `
  .pp-wrap * { box-sizing: border-box; }

  /* Tabs */
  .pp-tabs { display: flex; gap: 4px; background: #0c0c0e; border: 1px solid rgba(255,255,255,.06); border-radius: 12px; padding: 4px; margin-bottom: 1.5rem; width: fit-content; flex-wrap: wrap; }
  .pp-tab  { padding: .5rem 1.25rem; background: none; border: none; border-radius: 9px; font-family: 'DM Sans', sans-serif; font-size: .82rem; font-weight: 600; color: #555560; cursor: pointer; transition: all .15s; white-space: nowrap; display: flex; align-items: center; gap: 7px; }
  .pp-tab.on { background: rgba(255,215,0,.1); color: #FFD700; }
  .pp-tab-count { background: rgba(255,255,255,.08); border-radius: 20px; padding: 1px 7px; font-size: .68rem; font-weight: 700; }
  .pp-tab.on .pp-tab-count { background: rgba(255,215,0,.15); color: #FFD700; }

  /* Stats */
  .pp-stats { display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 1rem; margin-bottom: 1.5rem; }
  .pp-stat  { background: #111114; border: 1px solid rgba(255,255,255,.06); border-radius: 14px; padding: 1.1rem 1.25rem; display: flex; justify-content: space-between; align-items: center; position: relative; overflow: hidden; }
  .pp-stat::after { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px; background: var(--a, #FFD700); }
  .pp-stat-label { font-size: .67rem; font-weight: 700; text-transform: uppercase; letter-spacing: .08em; color: #555560; margin-bottom: 5px; }
  .pp-stat-val   { font-family: 'Playfair Display', serif; font-size: 1.6rem; font-weight: 800; line-height: 1; color: var(--a, #FFD700); }
  .pp-stat-icon  { width: 38px; height: 38px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: .85rem; flex-shrink: 0; }

  /* Toolbar */
  .pp-toolbar { display: flex; gap: 10px; margin-bottom: 1.25rem; flex-wrap: wrap; align-items: center; }
  .pp-search  { flex: 1; min-width: 200px; display: flex; align-items: center; gap: 10px; background: #111114; border: 1.5px solid rgba(255,255,255,.07); border-radius: 11px; padding: .65rem 1rem; transition: border-color .2s; }
  .pp-search:focus-within { border-color: rgba(255,215,0,.3); }
  .pp-search input { flex: 1; background: none; border: none; outline: none; color: #ECECEC; font-family: 'DM Sans', sans-serif; font-size: .88rem; min-width: 0; }
  .pp-search input::placeholder { color: #3a3a44; }

  .pp-select { background: #111114; border: 1.5px solid rgba(255,255,255,.07); border-radius: 11px; padding: .62rem .85rem; color: #ECECEC; font-family: 'DM Sans', sans-serif; font-size: .82rem; outline: none; cursor: pointer; }
  .pp-select:focus { border-color: rgba(255,215,0,.3); }

  .pp-viewtoggle { display: flex; background: #111114; border: 1.5px solid rgba(255,255,255,.07); border-radius: 11px; padding: 3px; flex-shrink: 0; }
  .pp-viewbtn { border: none; background: none; padding: .5rem .65rem; border-radius: 8px; color: #555560; cursor: pointer; display: flex; align-items: center; transition: all .15s; }
  .pp-viewbtn.on { background: rgba(255,215,0,.1); color: #FFD700; }

  /* Bulk bar */
  .pp-bulkbar { display: flex; align-items: center; gap: 12px; background: rgba(255,215,0,.06); border: 1px solid rgba(255,215,0,.18); border-radius: 11px; padding: .65rem 1rem; margin-bottom: 1rem; flex-wrap: wrap; }
  .pp-bulkbar span { font-size: .82rem; color: #FFD700; font-weight: 600; }
  .pp-bulk-btn { padding: .4rem .9rem; border-radius: 8px; font-size: .78rem; font-weight: 700; cursor: pointer; border: 1px solid; display: flex; align-items: center; gap: 5px; font-family: 'DM Sans', sans-serif; }

  /* Grid */
  .pp-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(290px, 1fr)); gap: 1rem; }

  /* Card */
  .pp-card { background: #111114; border: 1px solid rgba(255,255,255,.06); border-radius: 16px; overflow: hidden; display: flex; flex-direction: column; transition: border-color .2s, box-shadow .2s; position: relative; }
  .pp-card:hover { border-color: rgba(255,215,0,.12); box-shadow: 0 8px 28px rgba(0,0,0,.35); }
  .pp-card.selected { border-color: rgba(255,215,0,.4); box-shadow: 0 0 0 2px rgba(255,215,0,.15); }

  .pp-card-checkbox { position: absolute; top: 10px; left: 10px; z-index: 2; width: 20px; height: 20px; cursor: pointer; accent-color: #FFD700; }

  .pp-card-img { width: 100%; height: 176px; object-fit: cover; display: block; cursor: pointer; }
  .pp-card-no-img { width: 100%; height: 176px; background: #0c0c0e; display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 8px; color: #3a3a44; font-size: .8rem; border-bottom: 1px solid rgba(255,255,255,.04); cursor: pointer; }
  .pp-card-no-img svg { font-size: 1.75rem; }

  .pp-card-body { padding: 1rem; flex: 1; display: flex; flex-direction: column; gap: 8px; }

  .pp-card-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 8px; }
  .pp-card-name { font-weight: 700; color: #ECECEC; font-size: .9rem; line-height: 1.3; flex: 1; cursor: pointer; }
  .pp-card-name:hover { color: #FFD700; }

  .pp-pill { display: inline-flex; align-items: center; gap: 5px; border-radius: 20px; padding: 3px 10px; font-size: .65rem; font-weight: 700; flex-shrink: 0; white-space: nowrap; }
  .pp-pill-pending  { background: rgba(251,191,36,.1); color: #fbbf24; border: 1px solid rgba(251,191,36,.2); }
  .pp-pill-approved { background: rgba(34,197,94,.1);  color: #4ade80; border: 1px solid rgba(34,197,94,.2); }
  .pp-pill-rejected { background: rgba(239,68,68,.1);  color: #f87171; border: 1px solid rgba(239,68,68,.2); }
  .pp-pill-sync-ok   { background: rgba(34,197,94,.1);  color: #4ade80; border: 1px solid rgba(34,197,94,.2); }
  .pp-pill-sync-off  { background: rgba(255,255,255,.05); color: #9A9AA5; border: 1px solid rgba(255,255,255,.1); }
  .pp-pill-sync-fail { background: rgba(239,68,68,.1);  color: #f87171; border: 1px solid rgba(239,68,68,.2); }

  .pp-card-desc { font-size: .78rem; color: #555560; line-height: 1.55; }

  .pp-card-meta { display: flex; justify-content: space-between; align-items: center; }
  .pp-price     { font-family: 'JetBrains Mono', monospace; font-weight: 700; color: #FFD700; font-size: .95rem; }
  .pp-stock     { font-size: .72rem; color: #555560; }

  .pp-card-cat  { display: inline-block; background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.08); color: #9A9AA5; border-radius: 20px; padding: 2px 9px; font-size: .72rem; }

  .pp-craftsman { display: flex; align-items: center; gap: 6px; font-size: .76rem; color: #555560; }
  .pp-craftsman strong { color: #9A9AA5; font-weight: 600; }

  /* Rejection reason box */
  .pp-rejection-box { background: rgba(239,68,68,.06); border: 1px solid rgba(239,68,68,.15); border-radius: 9px; padding: .625rem .875rem; }
  .pp-rejection-label { font-size: .65rem; font-weight: 700; text-transform: uppercase; letter-spacing: .08em; color: #f87171; margin-bottom: 4px; }
  .pp-rejection-text  { font-size: .78rem; color: #fca5a5; line-height: 1.5; }

  /* Pending reason box */
  .pp-pending-box { background: rgba(251,191,36,.06); border: 1px solid rgba(251,191,36,.15); border-radius: 9px; padding: .625rem .875rem; }
  .pp-pending-label { font-size: .65rem; font-weight: 700; text-transform: uppercase; letter-spacing: .08em; color: #fbbf24; margin-bottom: 4px; }
  .pp-pending-text  { font-size: .78rem; color: #fde68a; line-height: 1.5; }

  /* Shopify sync box */
  .pp-sync-box { display: flex; align-items: center; justify-content: space-between; gap: 8px; background: rgba(149,128,255,.06); border: 1px solid rgba(149,128,255,.18); border-radius: 9px; padding: .55rem .75rem; }
  .pp-sync-box-left { display: flex; align-items: center; gap: 7px; font-size: .76rem; color: #b3a6ff; }
  .pp-sync-id { font-family: 'JetBrains Mono', monospace; font-size: .7rem; color: #9A9AA5; }
  .pp-sync-link { color: #b3a6ff; display: flex; align-items: center; gap: 4px; font-size: .74rem; font-weight: 700; text-decoration: none; }
  .pp-sync-link:hover { color: #FFD700; }

  /* Actions */
  .pp-actions { display: flex; gap: 8px; margin-top: auto; padding-top: 4px; }
  .pp-btn { flex: 1; padding: .55rem; border-radius: 8px; font-family: 'DM Sans', sans-serif; font-size: .78rem; font-weight: 700; cursor: pointer; border: 1px solid; transition: all .15s; display: flex; align-items: center; justify-content: center; gap: 5px; }
  .pp-btn-approve { background: rgba(34,197,94,.1); border-color: rgba(34,197,94,.25); color: #4ade80; }
  .pp-btn-approve:hover { background: rgba(34,197,94,.2); }
  .pp-btn-reject  { background: rgba(239,68,68,.08); border-color: rgba(239,68,68,.2);  color: #f87171; }
  .pp-btn-reject:hover  { background: rgba(239,68,68,.15); }
  .pp-btn-sync    { background: rgba(149,128,255,.08); border-color: rgba(149,128,255,.22); color: #b3a6ff; }
  .pp-btn-sync:hover { background: rgba(149,128,255,.16); }
  .pp-btn:disabled { opacity: .4; cursor: not-allowed; }

  /* Reject reason input */
  .pp-reject-input { width: 100%; background: #0c0c0e; border: 1.5px solid rgba(239,68,68,.2); border-radius: 8px; padding: .55rem .75rem; color: #ECECEC; font-family: 'DM Sans', sans-serif; font-size: .8rem; outline: none; resize: vertical; min-height: 60px; margin-top: 6px; transition: border-color .2s; }
  .pp-reject-input:focus { border-color: #ef4444; }
  .pp-reject-confirm { width: 100%; margin-top: 6px; padding: .5rem; background: linear-gradient(135deg, #ef4444, #dc2626); color: #fff; border: none; border-radius: 8px; font-family: 'DM Sans', sans-serif; font-size: .8rem; font-weight: 700; cursor: pointer; }
  .pp-reject-confirm:disabled { opacity: .4; cursor: not-allowed; }

  /* Table view (Zoho-style dense list) */
  .pp-table-wrap { background: #111114; border: 1px solid rgba(255,255,255,.06); border-radius: 14px; overflow: hidden; }
  .pp-table { width: 100%; border-collapse: collapse; font-family: 'DM Sans', sans-serif; }
  .pp-table thead th { text-align: left; font-size: .66rem; font-weight: 700; text-transform: uppercase; letter-spacing: .07em; color: #555560; padding: .8rem .9rem; border-bottom: 1px solid rgba(255,255,255,.06); background: #0c0c0e; white-space: nowrap; cursor: pointer; user-select: none; }
  .pp-table thead th:hover { color: #9A9AA5; }
  .pp-table thead th .sort-ic { margin-left: 5px; font-size: .62rem; opacity: .6; }
  .pp-table tbody tr { border-bottom: 1px solid rgba(255,255,255,.04); transition: background .12s; cursor: pointer; }
  .pp-table tbody tr:hover { background: rgba(255,255,255,.02); }
  .pp-table tbody tr.selected { background: rgba(255,215,0,.05); }
  .pp-table tbody tr:last-child { border-bottom: none; }
  .pp-table td { padding: .7rem .9rem; font-size: .8rem; color: #ECECEC; vertical-align: middle; }
  .pp-table-thumb { width: 34px; height: 34px; border-radius: 7px; object-fit: cover; flex-shrink: 0; }
  .pp-table-thumb-empty { width: 34px; height: 34px; border-radius: 7px; background: #0c0c0e; display: flex; align-items: center; justify-content: center; color: #3a3a44; font-size: .7rem; flex-shrink: 0; }
  .pp-table-name-cell { display: flex; align-items: center; gap: 10px; }
  .pp-table-name { font-weight: 600; color: #ECECEC; }
  .pp-table-name:hover { color: #FFD700; }
  .pp-table-sub { font-size: .7rem; color: #555560; }
  .pp-table td.num { font-family: 'JetBrains Mono', monospace; }
  .pp-table-actions { display: flex; gap: 6px; justify-content: flex-end; }
  .pp-table-icon-btn { width: 28px; height: 28px; border-radius: 7px; border: 1px solid; display: flex; align-items: center; justify-content: center; cursor: pointer; flex-shrink: 0; }

  /* Detail drawer */
  .pp-drawer-overlay { position: fixed; inset: 0; background: rgba(0,0,0,.6); z-index: 500; }
  .pp-drawer { position: fixed; top: 0; right: 0; bottom: 0; width: min(440px, 92vw); background: #111114; border-left: 1px solid rgba(255,255,255,.08); z-index: 501; display: flex; flex-direction: column; box-shadow: -20px 0 60px rgba(0,0,0,.5); animation: ppDrawerIn .2s ease; }
  @keyframes ppDrawerIn { from { transform: translateX(24px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
  .pp-drawer-head { display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border-bottom: 1px solid rgba(255,255,255,.06); flex-shrink: 0; }
  .pp-drawer-title { font-family: 'Playfair Display', serif; font-weight: 800; font-size: 1rem; color: #ECECEC; }
  .pp-drawer-close { background: none; border: none; color: #555560; cursor: pointer; font-size: 1rem; padding: 4px; }
  .pp-drawer-body { flex: 1; overflow-y: auto; padding: 1.25rem; display: flex; flex-direction: column; gap: 14px; }
  .pp-drawer-img { width: 100%; height: 200px; object-fit: cover; border-radius: 12px; }
  .pp-drawer-field-label { font-size: .65rem; font-weight: 700; text-transform: uppercase; letter-spacing: .07em; color: #555560; margin-bottom: 3px; }
  .pp-drawer-field-val { font-size: .86rem; color: #ECECEC; line-height: 1.5; }
  .pp-drawer-foot { padding: 1rem 1.25rem; border-top: 1px solid rgba(255,255,255,.06); flex-shrink: 0; display: flex; gap: 8px; }

  .pp-security-card { background: #111114; border: 1px solid rgba(255,255,255,.06); border-radius: 14px; padding: 1.25rem 1.375rem; margin-bottom: 1rem; }
  .pp-security-title { font-family: 'Playfair Display', serif; font-size: .9rem; font-weight: 800; color: #ECECEC; margin-bottom: .875rem; display: flex; align-items: center; gap: 8px; }
  .pp-security-row { display: flex; justify-content: space-between; align-items: center; padding: .6rem 0; border-bottom: 1px solid rgba(255,255,255,.04); }
  .pp-security-row:last-child { border-bottom: none; }
  .pp-security-key { font-size: .8rem; color: #555560; }
  .pp-security-val { font-size: .82rem; font-weight: 600; }

  .pp-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 4rem 2rem; gap: .75rem; background: #111114; border: 1px solid rgba(255,255,255,.06); border-radius: 16px; }
  .pp-empty h4 { font-family: 'Playfair Display', serif; font-size: 1rem; font-weight: 800; color: #ECECEC; margin: 0; }
  .pp-empty p  { font-size: .82rem; color: #555560; margin: 0; }

  .pp-spinner { display: flex; justify-content: center; padding: 4rem; }

  @media (max-width: 768px) {
    .pp-table thead { display: none; }
    .pp-table, .pp-table tbody, .pp-table tr, .pp-table td { display: block; width: 100%; }
    .pp-table tr { padding: .75rem .9rem; }
    .pp-table td { padding: .3rem 0; }
    .pp-table td.num { font-family: inherit; }
  }
`;

// Which issues make a product stay pending
function getPendingReasons(product) {
  const reasons = [];
  if (!product.name?.trim())        reasons.push("Product name is missing.");
  if (!product.description?.trim()) reasons.push("Description is missing.");
  if (!product.price || Number(product.price) <= 0) reasons.push("Price is not set or invalid.");
  if (!product.image)               reasons.push("No product image uploaded.");
  if (product.stock == null || product.stock < 0) reasons.push("Stock quantity is not set.");
  if (!product.category?.trim())    reasons.push("Category is not selected.");
  return reasons;
}

// Shopify sync status for a product: 'synced' | 'not_synced' | 'failed'
function getSyncStatus(product) {
  if (product.shopify_product_id) return "synced";
  if (product.is_approved && !product.shopify_product_id) return "failed";
  return "not_synced";
}

function SyncPill({ product }) {
  const status = getSyncStatus(product);
  if (status === "synced") {
    return <span className="pp-pill pp-pill-sync-ok"><FaSyncAlt size={9} /> Synced</span>;
  }
  if (status === "failed") {
    return <span className="pp-pill pp-pill-sync-fail"><FaExclamationTriangle size={9} /> Sync failed</span>;
  }
  return <span className="pp-pill pp-pill-sync-off">Not on Shopify</span>;
}

/**
 * Full product-moderation UI: Pending / Approved / Rejected / Security tabs,
 * grid + table views, search, category filter, sort, bulk approve, a detail
 * drawer, and Shopify sync status.
 *
 * `onChange` (optional): called after any action that could change the
 * pending count (approve, reject, bulk approve) — wire this up to a parent
 * dashboard so its sidebar badge / stat card stays accurate without the
 * parent needing to duplicate this component's fetch logic.
 */
export default function ProductsPage({ adminRole, shopifyStoreDomain, onChange }) {
  const [tab, setTab]       = useState("pending");
  const [view, setView]     = useState("grid"); // 'grid' | 'table'
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]); // unfiltered, for accurate stats
  const [loading, setLoading]   = useState(true);
  const [search, setSearch]     = useState("");
  const [categoryFilter, setCategoryFilter] = useState("All");
  const [sortKey, setSortKey]   = useState("created_at");
  const [sortDir, setSortDir]   = useState("desc");
  const [rejectingId, setRejectingId] = useState(null);
  const [rejectReasons, setRejectReasons] = useState({});
  const [actionLoading, setActionLoading] = useState(null);
  const [toast, setToast]   = useState(null);
  const [selectedIds, setSelectedIds] = useState({});
  const [detailProduct, setDetailProduct] = useState(null);
  const [detailReject, setDetailReject] = useState(false);
  const [detailRejectReason, setDetailRejectReason] = useState("");

  const canModerate = ["superadmin", "moderator"].includes(adminRole);

  const showToast = (type, text) => {
    setToast({ type, text });
    setTimeout(() => setToast(null), 4500);
  };

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const endpoint =
        tab === "pending"  ? "admin/products/?is_approved=false&status=pending" :
        tab === "approved" ? "admin/products/?is_approved=true" :
        tab === "rejected" ? "admin/products/?status=rejected" :
                             "admin/products/";
      const { data } = await api.get(endpoint);
      setProducts(Array.isArray(data) ? data : data.results || []);
    } catch {
      setProducts([]);
    } finally {
      setLoading(false);
    }
  }, [tab]);

  const fetchAllForStats = useCallback(async () => {
    try {
      const { data } = await api.get("admin/products/");
      setAllProducts(Array.isArray(data) ? data : data.results || []);
    } catch {
      setAllProducts([]);
    }
  }, []);

  useEffect(() => { fetchProducts(); setSelectedIds({}); }, [fetchProducts]);
  useEffect(() => { fetchAllForStats(); }, [fetchAllForStats, tab]);

  const approveProduct = async (id) => {
    setActionLoading(id + "-approve");
    try {
      await api.post(`admin/products/${id}/approve/`);
      showToast("ok", "Product approved and pushed to Shopify.");
      fetchProducts(); fetchAllForStats();
      onChange?.();
    } catch (e) {
      const status = e.response?.status;
      const msg = e.response?.data?.error || e.response?.data?.message;
      if (status === 502) {
        showToast("warn", msg || "Approved in the app, but the Shopify sync failed. Check the Sync column.");
      } else {
        showToast("err", msg || "Approval failed.");
      }
      fetchProducts(); fetchAllForStats();
      onChange?.();
    } finally {
      setActionLoading(null);
    }
  };

  const rejectProduct = async (id, reasonOverride) => {
    const reason = (reasonOverride ?? rejectReasons[id] ?? "").trim();
    if (!reason) { showToast("err", "Please provide a rejection reason."); return; }
    setActionLoading(id + "-reject");
    try {
      await api.post(`admin/products/${id}/reject/`, { reason });
      setRejectingId(null);
      setRejectReasons(prev => { const r = { ...prev }; delete r[id]; return r; });
      setDetailReject(false);
      setDetailRejectReason("");
      setDetailProduct(null);
      showToast("ok", "Product rejected. Craftsman will be notified.");
      fetchProducts(); fetchAllForStats();
      onChange?.();
    } catch (e) {
      showToast("err", e.response?.data?.error || "Rejection failed.");
    } finally {
      setActionLoading(null);
    }
  };

  const bulkApprove = async () => {
    const ids = Object.keys(selectedIds).filter(id => selectedIds[id]);
    if (!ids.length) return;
    if (!window.confirm(`Approve ${ids.length} product(s) and push to Shopify?`)) return;
    setActionLoading("bulk-approve");
    const results = await Promise.allSettled(ids.map(id => api.post(`admin/products/${id}/approve/`)));
    const failed = results.filter(r => r.status === "rejected").length;
    showToast(
      failed ? "warn" : "ok",
      failed ? `${ids.length - failed} approved, ${failed} failed.` : `${ids.length} product(s) approved.`
    );
    setActionLoading(null);
    setSelectedIds({});
    fetchProducts(); fetchAllForStats();
    onChange?.();
  };

  const categories = useMemo(() => {
    const set = new Set(allProducts.map(p => p.category).filter(Boolean));
    return ["All", ...Array.from(set)];
  }, [allProducts]);

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    let list = products.filter(p => {
      const matchesSearch = !q ||
        (p.name || "").toLowerCase().includes(q) ||
        (p.craftsman_name || "").toLowerCase().includes(q) ||
        (p.category || "").toLowerCase().includes(q);
      const matchesCategory = categoryFilter === "All" || p.category === categoryFilter;
      return matchesSearch && matchesCategory;
    });

    list = [...list].sort((a, b) => {
      let av = a[sortKey], bv = b[sortKey];
      if (sortKey === "price" || sortKey === "stock") { av = Number(av) || 0; bv = Number(bv) || 0; }
      else if (sortKey === "created_at") { av = new Date(av || 0).getTime(); bv = new Date(bv || 0).getTime(); }
      else { av = (av || "").toString().toLowerCase(); bv = (bv || "").toString().toLowerCase(); }
      if (av < bv) return sortDir === "asc" ? -1 : 1;
      if (av > bv) return sortDir === "asc" ? 1 : -1;
      return 0;
    });
    return list;
  }, [products, search, categoryFilter, sortKey, sortDir]);

  const toggleSort = (key) => {
    if (sortKey === key) setSortDir(d => (d === "asc" ? "desc" : "asc"));
    else { setSortKey(key); setSortDir("asc"); }
  };

  const sortIcon = (key) => {
    if (sortKey !== key) return <FaSort className="sort-ic" />;
    return sortDir === "asc" ? <FaSortUp className="sort-ic" /> : <FaSortDown className="sort-ic" />;
  };

  const toggleSelect = (id) => setSelectedIds(prev => ({ ...prev, [id]: !prev[id] }));
  const toggleSelectAll = () => {
    const allSelected = filtered.every(p => selectedIds[p.id]);
    const next = { ...selectedIds };
    filtered.forEach(p => { next[p.id] = !allSelected; });
    setSelectedIds(next);
  };
  const selectedCount = Object.values(selectedIds).filter(Boolean).length;

  const stats = useMemo(() => {
    const pending  = allProducts.filter(p => !p.is_approved && p.status !== "rejected").length;
    const approved = allProducts.filter(p => p.is_approved).length;
    const rejected = allProducts.filter(p => p.status === "rejected").length;
    const synced   = allProducts.filter(p => p.is_approved && p.shopify_product_id).length;
    const syncFail = allProducts.filter(p => p.is_approved && !p.shopify_product_id).length;
    return [
      { lbl: "Pending Review",  val: pending,  a: "#fbbf24", icon: <FaClock /> },
      { lbl: "Approved",        val: approved, a: "#22c55e", icon: <FaCheckCircle /> },
      { lbl: "Rejected",        val: rejected, a: "#f87171", icon: <FaTimesCircle /> },
      { lbl: "Synced to Shopify", val: synced, a: "#b3a6ff", icon: <FaSyncAlt /> },
      { lbl: "Sync Issues",     val: syncFail, a: "#f87171", icon: <FaExclamationTriangle /> },
    ];
  }, [allProducts]);

  const TABS = [
    { key: "pending",  label: "Pending Review",  icon: <FaClock /> },
    { key: "approved", label: "Approved",         icon: <FaCheckCircle /> },
    { key: "rejected", label: "Rejected",         icon: <FaTimesCircle /> },
    { key: "security", label: "Security",         icon: <FaShieldAlt /> },
  ];

  const shopifyLink = (product) => {
    if (!shopifyStoreDomain || !product.shopify_product_id) return null;
    return `https://${shopifyStoreDomain}/admin/products/${product.shopify_product_id}`;
  };

  const copyToClipboard = (text) => {
    if (navigator.clipboard) navigator.clipboard.writeText(text).then(() => showToast("ok", "Copied."));
  };

  // ── Table row renderer (shared by pending / approved / rejected) ──────
  const renderTableRow = (p, showApproveReject) => {
    const issues = tab === "pending" ? getPendingReasons(p) : [];
    return (
      <tr
        key={p.id}
        className={selectedIds[p.id] ? "selected" : ""}
        onClick={(e) => { if (e.target.type !== "checkbox") setDetailProduct(p); }}
      >
        {tab === "pending" && canModerate && (
          <td onClick={e => e.stopPropagation()}>
            <input type="checkbox" checked={!!selectedIds[p.id]} onChange={() => toggleSelect(p.id)} style={{ accentColor: "#FFD700", width: 16, height: 16, cursor: "pointer" }} />
          </td>
        )}
        <td>
          <div className="pp-table-name-cell">
            {p.image
              ? <img src={p.image} alt="" className="pp-table-thumb" onError={e => { e.target.style.display = "none"; }} />
              : <div className="pp-table-thumb-empty"><FaBox size={12} /></div>}
            <div>
              <div className="pp-table-name">{p.name || "Unnamed product"}</div>
              <div className="pp-table-sub">{p.category || "No category"}</div>
            </div>
          </div>
        </td>
        <td className="num">KES {parseFloat(p.price || 0).toLocaleString()}</td>
        <td className="num">{p.stock ?? "—"}</td>
        <td>{p.craftsman_name || "—"}</td>
        <td><SyncPill product={p} /></td>
        {tab === "pending" && <td>{issues.length ? <span style={{ color: "#fbbf24", fontSize: ".74rem" }}>{issues.length} issue{issues.length > 1 ? "s" : ""}</span> : <span style={{ color: "#4ade80", fontSize: ".74rem" }}>Ready</span>}</td>}
        {tab === "rejected" && <td style={{ maxWidth: 200, color: "#f87171", fontSize: ".76rem" }}>{p.rejection_reason ? (p.rejection_reason.length > 40 ? p.rejection_reason.slice(0, 40) + "…" : p.rejection_reason) : "—"}</td>}
        {canModerate && showApproveReject && (
          <td onClick={e => e.stopPropagation()}>
            <div className="pp-table-actions">
              <button
                className="pp-table-icon-btn"
                style={{ borderColor: "rgba(34,197,94,.25)", color: "#4ade80", background: "rgba(34,197,94,.08)" }}
                disabled={(tab === "pending" && issues.length > 0) || actionLoading === p.id + "-approve"}
                onClick={() => approveProduct(p.id)}
                title="Approve"
              >
                <FaCheckCircle size={11} />
              </button>
              <button
                className="pp-table-icon-btn"
                style={{ borderColor: "rgba(239,68,68,.2)", color: "#f87171", background: "rgba(239,68,68,.06)" }}
                onClick={() => { setDetailProduct(p); setDetailReject(true); }}
                title="Reject"
              >
                <FaTimesCircle size={11} />
              </button>
            </div>
          </td>
        )}
      </tr>
    );
  };

  const tableHead = (
    <thead>
      <tr>
        {tab === "pending" && canModerate && (
          <th style={{ width: 34 }}>
            <input type="checkbox" checked={filtered.length > 0 && filtered.every(p => selectedIds[p.id])} onChange={toggleSelectAll} style={{ accentColor: "#FFD700", width: 16, height: 16, cursor: "pointer" }} />
          </th>
        )}
        <th onClick={() => toggleSort("name")}>Product {sortIcon("name")}</th>
        <th onClick={() => toggleSort("price")}>Price {sortIcon("price")}</th>
        <th onClick={() => toggleSort("stock")}>Stock {sortIcon("stock")}</th>
        <th onClick={() => toggleSort("craftsman_name")}>Craftsman {sortIcon("craftsman_name")}</th>
        <th>Shopify</th>
        {tab === "pending" && <th>Status</th>}
        {tab === "rejected" && <th>Reason</th>}
        {canModerate && (tab === "pending" || tab === "rejected") && <th style={{ textAlign: "right" }}>Actions</th>}
      </tr>
    </thead>
  );

  const renderCard = (p, mode) => {
    const issues = mode === "pending" ? getPendingReasons(p) : [];
    const isRejecting = rejectingId === p.id;
    return (
      <div key={p.id} className={`pp-card${selectedIds[p.id] ? " selected" : ""}`}>
        {mode === "pending" && canModerate && (
          <input
            type="checkbox"
            className="pp-card-checkbox"
            checked={!!selectedIds[p.id]}
            onChange={() => toggleSelect(p.id)}
          />
        )}
        {p.image
          ? <img src={p.image} alt={p.name} className="pp-card-img" onClick={() => setDetailProduct(p)} onError={e => { e.target.style.display = "none"; }} />
          : <div className="pp-card-no-img" onClick={() => setDetailProduct(p)}><FaBox /><span>No image uploaded</span></div>
        }
        <div className="pp-card-body">
          <div className="pp-card-top">
            <span className="pp-card-name" onClick={() => setDetailProduct(p)}>{p.name || "Unnamed product"}</span>
            <span className={`pp-pill pp-pill-${mode}`}>{mode === "pending" ? "Pending" : mode === "approved" ? "Live" : "Rejected"}</span>
          </div>

          {p.description && (
            <p className="pp-card-desc">{p.description.length > 90 ? p.description.slice(0, 90) + "…" : p.description}</p>
          )}

          <div className="pp-card-meta">
            <span className="pp-price">KES {parseFloat(p.price || 0).toLocaleString()}</span>
            <span className="pp-stock">Stock: {p.stock ?? "—"}</span>
          </div>

          {p.category && <span className="pp-card-cat">{p.category}</span>}

          <div className="pp-craftsman">
            <FaUser style={{ fontSize: ".7rem" }} /> By: <strong>{p.craftsman_name || "—"}</strong>
          </div>

          {mode !== "pending" && (
            <div className="pp-sync-box">
              <div className="pp-sync-box-left">
                <FaSyncAlt size={11} />
                <SyncPill product={p} />
              </div>
              {shopifyLink(p) && (
                <a className="pp-sync-link" href={shopifyLink(p)} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}>
                  View <FaExternalLinkAlt size={9} />
                </a>
              )}
            </div>
          )}

          {mode === "pending" && issues.length > 0 && (
            <div className="pp-pending-box">
              <div className="pp-pending-label">Why it is pending</div>
              {issues.map((r, i) => <div key={i} className="pp-pending-text">• {r}</div>)}
            </div>
          )}

          {mode === "rejected" && p.rejection_reason && (
            <div className="pp-rejection-box">
              <div className="pp-rejection-label">Rejection reason given</div>
              <div className="pp-rejection-text">{p.rejection_reason}</div>
            </div>
          )}

          {canModerate && mode === "pending" && (
            !isRejecting ? (
              <div className="pp-actions">
                <button
                  className="pp-btn pp-btn-approve"
                  disabled={issues.length > 0 || actionLoading === p.id + "-approve"}
                  onClick={() => approveProduct(p.id)}
                  title={issues.length > 0 ? "Fix issues above before approving" : "Approve and push to Shopify"}
                >
                  <FaCheckCircle size={11} />
                  {actionLoading === p.id + "-approve" ? "..." : "Approve"}
                </button>
                <button className="pp-btn pp-btn-reject" onClick={() => setRejectingId(p.id)}>
                  <FaTimesCircle size={11} /> Reject
                </button>
              </div>
            ) : (
              <div style={{ marginTop: 4 }}>
                <div style={{ fontSize: ".72rem", color: "#f87171", fontWeight: 700, marginBottom: 3 }}>Rejection reason (sent to craftsman)</div>
                <textarea
                  className="pp-reject-input"
                  placeholder="e.g. Image quality is too low, description is unclear..."
                  value={rejectReasons[p.id] || ""}
                  onChange={e => setRejectReasons({ ...rejectReasons, [p.id]: e.target.value })}
                />
                <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
                  <button className="pp-btn pp-btn-reject" style={{ flex: "0 0 auto", padding: ".45rem .875rem" }} onClick={() => setRejectingId(null)}>Cancel</button>
                  <button
                    className="pp-reject-confirm"
                    disabled={!(rejectReasons[p.id] || "").trim() || actionLoading === p.id + "-reject"}
                    onClick={() => rejectProduct(p.id)}
                  >
                    {actionLoading === p.id + "-reject" ? "Rejecting..." : "Confirm Rejection"}
                  </button>
                </div>
              </div>
            )
          )}

          {canModerate && mode === "rejected" && (
            <div className="pp-actions">
              <button className="pp-btn pp-btn-approve" disabled={actionLoading === p.id + "-approve"} onClick={() => approveProduct(p.id)}>
                <FaCheckCircle size={11} /> Re-approve
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  const emptyState = (icon, title, text) => (
    <div className="pp-empty">
      {icon}
      <h4>{title}</h4>
      <p>{text}</p>
    </div>
  );

  const listOrTable = (mode, showApproveReject) => {
    if (loading) return <div className="pp-spinner"><div className="spinner-border" style={{ color: "#FFD700", width: "2rem", height: "2rem" }} role="status" /></div>;
    if (filtered.length === 0) {
      if (mode === "pending")  return emptyState(<FaBox style={{ fontSize: "2rem", color: "#333" }} />, "No pending products", "All products have been reviewed. New submissions will appear here.");
      if (mode === "approved") return emptyState(<FaCheckCircle style={{ fontSize: "2rem", color: "#22c55e" }} />, "No approved products yet", "Products you approve will appear here.");
      return emptyState(<FaTimesCircle style={{ fontSize: "2rem", color: "#f87171" }} />, "No rejected products", "Products you reject will appear here with the reason given.");
    }
    if (view === "table") {
      return (
        <div className="pp-table-wrap">
          <table className="pp-table">
            {tableHead}
            <tbody>{filtered.map(p => renderTableRow(p, showApproveReject))}</tbody>
          </table>
        </div>
      );
    }
    return <div className="pp-grid">{filtered.map(p => renderCard(p, mode))}</div>;
  };

  return (
    <div className="pp-wrap">
      <style>{S}</style>

      {toast && (
        <div style={{
          background: toast.type === "ok" ? "rgba(34,197,94,.1)" : toast.type === "warn" ? "rgba(251,191,36,.1)" : "rgba(239,68,68,.1)",
          border: `1px solid ${toast.type === "ok" ? "rgba(34,197,94,.25)" : toast.type === "warn" ? "rgba(251,191,36,.25)" : "rgba(239,68,68,.25)"}`,
          color: toast.type === "ok" ? "#4ade80" : toast.type === "warn" ? "#fbbf24" : "#f87171",
          borderRadius: 10, padding: ".75rem 1rem", fontSize: ".84rem", fontWeight: 600,
          marginBottom: "1rem",
        }}>
          {toast.text}
        </div>
      )}

      {/* Stats — Zoho-style KPI strip, always visible, always accurate across tabs */}
      {tab !== "security" && (
        <div className="pp-stats">
          {stats.map((s, i) => (
            <div key={i} className="pp-stat" style={{ "--a": s.a }}>
              <div>
                <div className="pp-stat-label">{s.lbl}</div>
                <div className="pp-stat-val">{s.val}</div>
              </div>
              <div className="pp-stat-icon" style={{ background: `${s.a}18`, color: s.a }}>{s.icon}</div>
            </div>
          ))}
        </div>
      )}

      {/* Tabs */}
      <div className="pp-tabs">
        {TABS.map(t => (
          <button key={t.key} className={`pp-tab${tab === t.key ? " on" : ""}`} onClick={() => { setTab(t.key); setSearch(""); setCategoryFilter("All"); }}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      {tab !== "security" && (
        <>
          <div className="pp-toolbar">
            <div className="pp-search">
              <FaSearch style={{ color: "#3a3a44", fontSize: ".82rem", flexShrink: 0 }} />
              <input placeholder="Search by name, craftsman or category..." value={search} onChange={e => setSearch(e.target.value)} />
              {search && <span onClick={() => setSearch("")} style={{ color: "#555", cursor: "pointer", fontSize: ".78rem" }}>Clear</span>}
            </div>
            <select className="pp-select" value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)}>
              {categories.map(c => <option key={c} value={c}>{c === "All" ? "All categories" : c}</option>)}
            </select>
            <div className="pp-viewtoggle">
              <button className={`pp-viewbtn${view === "grid" ? " on" : ""}`} onClick={() => setView("grid")} title="Grid view"><FaTh size={12} /></button>
              <button className={`pp-viewbtn${view === "table" ? " on" : ""}`} onClick={() => setView("table")} title="Table view"><FaList size={12} /></button>
            </div>
          </div>

          {tab === "pending" && canModerate && selectedCount > 0 && (
            <div className="pp-bulkbar">
              <span>{selectedCount} selected</span>
              <button
                className="pp-bulk-btn"
                style={{ background: "rgba(34,197,94,.12)", borderColor: "rgba(34,197,94,.3)", color: "#4ade80" }}
                disabled={actionLoading === "bulk-approve"}
                onClick={bulkApprove}
              >
                <FaCheckCircle size={11} /> {actionLoading === "bulk-approve" ? "Approving..." : "Bulk approve & push to Shopify"}
              </button>
              <button
                className="pp-bulk-btn"
                style={{ background: "rgba(255,255,255,.05)", borderColor: "rgba(255,255,255,.15)", color: "#9A9AA5" }}
                onClick={() => setSelectedIds({})}
              >
                Clear selection
              </button>
            </div>
          )}

          {listOrTable(tab, true)}
        </>
      )}

      {/* ── SECURITY ── */}
      {tab === "security" && (
        <div style={{ maxWidth: 640 }}>
          <div className="pp-security-card">
            <div className="pp-security-title"><FaShieldAlt style={{ color: "#FFD700" }} /> Product Moderation Rules</div>
            {[
              ["Auto-approve",       "Disabled. All products require manual review before going live."],
              ["Who can approve",    "Superadmin and Moderator roles only."],
              ["Who can reject",     "Superadmin and Moderator roles only."],
              ["Rejection reason",   "Required. Craftsman receives the reason so they can fix and resubmit."],
              ["Re-approval",        "A rejected product can be re-approved if the craftsman fixes the issues."],
              ["Image requirement",  "A product image is required before approval can be granted."],
              ["Price requirement",  "Price must be set and greater than zero."],
              ["Category required",  "Products without a category cannot be approved."],
            ].map(([key, val], i) => (
              <div key={i} className="pp-security-row">
                <span className="pp-security-key">{key}</span>
                <span className="pp-security-val" style={{ color: "#9A9AA5", textAlign: "right", maxWidth: "60%" }}>{val}</span>
              </div>
            ))}
          </div>

          <div className="pp-security-card">
            <div className="pp-security-title"><FaSyncAlt style={{ color: "#b3a6ff" }} /> Shopify Integration</div>
            {[
              ["Sync trigger",       "Approving a product automatically pushes it to Shopify as a new product."],
              ["Sync failure",       "If Shopify rejects the push, the product stays approved in the app but is flagged 'Sync failed' until retried."],
              ["Duplicate protection", "A product already linked to a Shopify ID is never re-pushed on re-approval."],
              ["Inventory",          "Stock quantity is pushed to Shopify inventory at the same location on approval."],
              ["Images",             "The product image is uploaded to Shopify only if it has a public URL."],
            ].map(([key, val], i) => (
              <div key={i} className="pp-security-row">
                <span className="pp-security-key">{key}</span>
                <span className="pp-security-val" style={{ color: "#9A9AA5", textAlign: "right", maxWidth: "60%" }}>{val}</span>
              </div>
            ))}
          </div>

          <div className="pp-security-card">
            <div className="pp-security-title"><FaShieldAlt style={{ color: "#22c55e" }} /> Content Policy</div>
            {[
              ["Prohibited content",     "No counterfeit goods, illegal items, or misleading descriptions."],
              ["Image standards",        "Clear, well-lit photos of the actual product. No stock photos."],
              ["Pricing",                "Must match what the craftsman charges in person."],
              ["Description accuracy",   "Must accurately describe materials, dimensions and usage."],
              ["Craftsman verification", "Only verified (approved) craftsmen may list products."],
            ].map(([key, val], i) => (
              <div key={i} className="pp-security-row">
                <span className="pp-security-key">{key}</span>
                <span className="pp-security-val" style={{ color: "#9A9AA5", textAlign: "right", maxWidth: "60%" }}>{val}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── DETAIL DRAWER (Zoho-style record panel) ── */}
      {detailProduct && (
        <>
          <div className="pp-drawer-overlay" onClick={() => { setDetailProduct(null); setDetailReject(false); setDetailRejectReason(""); }} />
          <div className="pp-drawer">
            <div className="pp-drawer-head">
              <span className="pp-drawer-title">{detailProduct.name || "Unnamed product"}</span>
              <button className="pp-drawer-close" onClick={() => { setDetailProduct(null); setDetailReject(false); setDetailRejectReason(""); }}><FaTimes /></button>
            </div>
            <div className="pp-drawer-body">
              {detailProduct.image
                ? <img src={detailProduct.image} alt={detailProduct.name} className="pp-drawer-img" />
                : <div className="pp-card-no-img" style={{ height: 200, borderRadius: 12 }}><FaBox /><span>No image uploaded</span></div>
              }

              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <span className={`pp-pill pp-pill-${detailProduct.status === "rejected" ? "rejected" : detailProduct.is_approved ? "approved" : "pending"}`}>
                  {detailProduct.status === "rejected" ? "Rejected" : detailProduct.is_approved ? "Live" : "Pending"}
                </span>
                <SyncPill product={detailProduct} />
                {detailProduct.category && <span className="pp-card-cat">{detailProduct.category}</span>}
              </div>

              <div>
                <div className="pp-drawer-field-label">Description</div>
                <div className="pp-drawer-field-val">{detailProduct.description || "—"}</div>
              </div>

              <div style={{ display: "flex", gap: 20 }}>
                <div>
                  <div className="pp-drawer-field-label">Price</div>
                  <div className="pp-drawer-field-val" style={{ color: "#FFD700", fontWeight: 700 }}>KES {parseFloat(detailProduct.price || 0).toLocaleString()}</div>
                </div>
                <div>
                  <div className="pp-drawer-field-label">Stock</div>
                  <div className="pp-drawer-field-val">{detailProduct.stock ?? "—"}</div>
                </div>
              </div>

              <div>
                <div className="pp-drawer-field-label">Craftsman</div>
                <div className="pp-drawer-field-val">{detailProduct.craftsman_name || "—"}</div>
              </div>

              <div>
                <div className="pp-drawer-field-label">Shopify Sync</div>
                {detailProduct.shopify_product_id ? (
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                    <span className="pp-sync-id">ID: {detailProduct.shopify_product_id}</span>
                    <FaCopy size={11} style={{ color: "#555560", cursor: "pointer" }} onClick={() => copyToClipboard(detailProduct.shopify_product_id)} title="Copy Shopify product ID" />
                    {shopifyLink(detailProduct) && (
                      <a className="pp-sync-link" href={shopifyLink(detailProduct)} target="_blank" rel="noreferrer">
                        Open in Shopify <FaExternalLinkAlt size={9} />
                      </a>
                    )}
                  </div>
                ) : (
                  <div className="pp-drawer-field-val" style={{ color: detailProduct.is_approved ? "#f87171" : "#9A9AA5" }}>
                    {detailProduct.is_approved ? "Approved but not yet on Shopify — the push may have failed. Try re-approving." : "Not synced yet — happens automatically on approval."}
                  </div>
                )}
              </div>

              {tab === "pending" && getPendingReasons(detailProduct).length > 0 && (
                <div className="pp-pending-box">
                  <div className="pp-pending-label">Why it is pending</div>
                  {getPendingReasons(detailProduct).map((r, i) => <div key={i} className="pp-pending-text">• {r}</div>)}
                </div>
              )}

              {detailProduct.rejection_reason && (
                <div className="pp-rejection-box">
                  <div className="pp-rejection-label">Rejection reason given</div>
                  <div className="pp-rejection-text">{detailProduct.rejection_reason}</div>
                </div>
              )}

              {detailReject && (
                <div>
                  <div style={{ fontSize: ".72rem", color: "#f87171", fontWeight: 700, marginBottom: 3 }}>Rejection reason (sent to craftsman)</div>
                  <textarea
                    className="pp-reject-input"
                    placeholder="e.g. Image quality is too low, description is unclear..."
                    value={detailRejectReason}
                    onChange={e => setDetailRejectReason(e.target.value)}
                  />
                </div>
              )}
            </div>

            {canModerate && (
              <div className="pp-drawer-foot">
                {!detailReject ? (
                  <>
                    {(tab === "pending" || tab === "rejected") && (
                      <button
                        className="pp-btn pp-btn-approve"
                        disabled={(tab === "pending" && getPendingReasons(detailProduct).length > 0) || actionLoading === detailProduct.id + "-approve"}
                        onClick={() => approveProduct(detailProduct.id)}
                      >
                        <FaCheckCircle size={11} /> {tab === "rejected" ? "Re-approve" : "Approve & push to Shopify"}
                      </button>
                    )}
                    {tab === "pending" && (
                      <button className="pp-btn pp-btn-reject" onClick={() => setDetailReject(true)}>
                        <FaTimesCircle size={11} /> Reject
                      </button>
                    )}
                  </>
                ) : (
                  <>
                    <button className="pp-btn pp-btn-reject" style={{ flex: "0 0 auto" }} onClick={() => { setDetailReject(false); setDetailRejectReason(""); }}>Cancel</button>
                    <button
                      className="pp-reject-confirm"
                      disabled={!detailRejectReason.trim() || actionLoading === detailProduct.id + "-reject"}
                      onClick={() => rejectProduct(detailProduct.id, detailRejectReason)}
                    >
                      {actionLoading === detailProduct.id + "-reject" ? "Rejecting..." : "Confirm Rejection"}
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}